import React, { useState } from 'react';
import { FiImage, FiTrash2, FiRepeat, FiExternalLink, FiPlusCircle } from 'react-icons/fi';
import MediaPicker from './MediaPicker';
import './ImageField.css';

/**
 * Image URL field backed by the media library.
 * The stored value is always a plain URL string.
 */
const ImageField = ({
  label,
  value,
  onChange,
  folder = 'cms',
  hint,
  error,
  compact = false,
  disabled = false,
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [broken, setBroken] = useState(false);

  const handleSelect = (url) => {
    setBroken(false);
    onChange(url);
  };

  return (
    <div className={`image-field ${compact ? 'compact' : ''} ${error ? 'has-error' : ''}`}>
      {label && <label className="if-label">{label}</label>}

      {value ? (
        <div className="if-preview">
          <div className="if-thumb">
            {broken ? (
              <span className="if-broken"><FiImage /></span>
            ) : (
              <img src={value} alt={label || 'Selected'} onError={() => setBroken(true)} />
            )}
          </div>
          <div className="if-meta">
            <span className="if-url" title={value}>{value}</span>
            <div className="if-actions">
              <button type="button" className="if-btn" onClick={() => setPickerOpen(true)} disabled={disabled}>
                <FiRepeat /> Replace
              </button>
              <a className="if-btn" href={value} target="_blank" rel="noreferrer">
                <FiExternalLink /> Open
              </a>
              <button type="button" className="if-btn danger" onClick={() => onChange('')} disabled={disabled}>
                <FiTrash2 /> Remove
              </button>
            </div>
          </div>
        </div>
      ) : (
        <button type="button" className="if-empty" onClick={() => setPickerOpen(true)} disabled={disabled}>
          <span className="if-empty-icon"><FiPlusCircle /></span>
          <span className="if-empty-text">
            <strong>Choose an image</strong>
            <small>Pick from the library, upload, or paste a URL</small>
          </span>
        </button>
      )}

      {hint && !error && <span className="if-hint">{hint}</span>}
      {error && <span className="if-error">{error}</span>}

      <MediaPicker
        isOpen={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onSelect={handleSelect}
        folder={folder}
        title={label ? `Select ${label}` : 'Select Image'}
      />
    </div>
  );
};

export default ImageField;
